export const RADIO_BAND_OPTIONS = [
  { value: '2.4GHz', label: '2.4 GHz only' },
  { value: '5GHz', label: '5 GHz only' },
  { value: '6GHz', label: '6 GHz only' },
  { value: 'all', label: '2.4 + 5 GHz' },
  { value: '2.4GHz,6GHz', label: '2.4 + 6 GHz' },
];

export function formatRadioProfileBand(band) {
  const opt = RADIO_BAND_OPTIONS.find((o) => o.value === band);
  return opt ? opt.label : band;
}

export function formatRadioProfileOptionLabel(profile) {
  const name = profile?.name || profile?.id || '';
  if (!profile?.band) return name;
  return `${name} — ${formatRadioProfileBand(profile.band)}`;
}
